// src/components/roles/RoleForm.jsx - Translated version
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TextField,
  Alert,
} from '@mui/material';
import { FormSection } from '../../../components/common/form';

const RoleForm = memo(function RoleForm({
  formData,
  onInputChange,
  validationErrors = {},
  loading = false,
  mode = 'create', // 'create' or 'edit'
}) {
  const { t } = useTranslation(['roles', 'common']);

  const handleNameChange = useCallback((event) => {
    onInputChange('name', event.target.value);
  }, [onInputChange]);

  const handleDescriptionChange = useCallback((event) => {
    onInputChange('description', event.target.value);
  }, [onInputChange]);

  return (
    <FormSection title={mode === 'create' ? t('roles:form.create_title') : t('roles:form.edit_title')}>
      <TextField
        fullWidth
        label={t('roles:labels.name')}
        value={formData.name || ''}
        onChange={handleNameChange}
        error={!!validationErrors.name}
        helperText={validationErrors.name || t('roles:form.name_helper')}
        required
        disabled={loading}
        placeholder={t('roles:placeholders.name')}
        inputProps={{ maxLength: 100 }}
      />
      <TextField
        fullWidth
        label={t('roles:labels.description')}
        multiline
        rows={4}
        value={formData.description || ''}
        onChange={handleDescriptionChange}
        error={!!validationErrors.description}
        helperText={validationErrors.description || t('roles:form.description_helper')}
        required
        disabled={loading}
        placeholder={t('roles:placeholders.description')}
        inputProps={{ maxLength: 500 }}
      />
      {mode === 'create' && (
        <Alert severity="info">
          {t('roles:info.after_creation')}
        </Alert>
      )}
    </FormSection>
  );
});

export default RoleForm;